<template>
  <div>
    <!-- Empty State -->
    <div v-if="!filtersApplied" class="w-full flex flex-col items-center fade-in">
      <img src="https://publicassets.foreplay.co/swipefile-empty.png" style="width: 232px; height: 212px;">
      <BaseText type="heading" size="md" class="text-black mt-9">
        {{ headerText }}
      </BaseText>
      <BaseText type="body" size="md" class="text-text-normal mt-2 text-center" :style="{ maxWidth: `${maxSubheaderWidth}px` }">
        {{ subheaderText }}
      </BaseText>
      <div v-if="!hideActionButtons" class="flex items-center gap-3 mt-9">
        <a href="https://chromewebstore.google.com/detail/ad-library-save-ads-faceb/eaancnanphggbfliooildilcnjocggjm" target="_blank"
        class="secondary-btn flex items-center gap-1.5 pl-2 pr-3 py-1.5 rounded-md">
          <ChromeIcon class="text-icon-normal" :width="20" :height="20" />
          <BaseText type="label" size="sm" class="text-text-muted">
            Download the Chrome Extension
          </BaseText>
        </a>
        <router-link :to="{name: 'DiscoveryView'}" class="secondary-btn flex items-center gap-1.5 pl-2 pr-3 py-1.5 rounded-md">
          <SearchIcon class="text-icon-normal" />
          <BaseText type="label" size="sm" class="text-text-muted">
            Search Discovery
          </BaseText>
        </router-link>
      </div>
      <BaseText type="body" size="sm" class="text-text-normal" :class="hideActionButtons ? 'mt-12' : 'mt-20'">
        Was this an error?
      </BaseText>
      <button class="flex items-center gap-1.5 mt-2 pl-2 pr-3 py-1.5 rounded-md transition-colors duration-100 hover:bg-neutral-25"
      @click="showIntercom">
        <ContactSupportIcon class="text-icon-normal" />
        <BaseText type="label" size="sm" class="text-text-muted">
          Contact Support
        </BaseText>
      </button>
    </div>
    <!-- Empty State with Filters -->
    <div v-else class="w-full flex flex-col items-center fade-in">
      <img src="https://publicassets.foreplay.co/swipefile-empty.png" style="width: 232px; height: 212px;">
      <BaseText type="heading" size="md" class="text-black mt-9">
        {{ hasSearchQuery ? 'No results found' : 'Too many filters' }}
      </BaseText>
      <BaseText type="body" size="md" class="text-text-normal mt-2 text-center" style="max-width: 390px;">
        We were unable to find any ads that meet your filter or search criteria.
      </BaseText>
      <button class="secondary-btn flex items-center gap-1.5 pl-2 pr-3 py-1.5 rounded-md mt-9"
      @click="$emit('clearFilters')">
        <ClearFiltersIcon class="text-icon-normal" />
        <BaseText type="label" size="sm" class="text-text-muted">
          Clear filters
        </BaseText>
      </button>
    </div>
  </div>
</template>

<script>
// Icons
import ChromeIcon from '../globals/Icons/OnboardIcons/ChromeIcon.vue'
import SearchIcon from '../globals/Icons/SearchIcon.vue'
import ContactSupportIcon from '../globals/Icons/ContactSupportIcon.vue'
import ClearFiltersIcon from '../globals/Icons/FilterIcons/ClearFiltersIcon.vue'

export default {
  name: 'LibraryEmptyState',
  components: {
    ChromeIcon,
    SearchIcon,
    ContactSupportIcon,
    ClearFiltersIcon
  },
  props: {
    headerText: {
      type: String
    },
    subheaderText: {
      type: String
    },
    filtersApplied: {
      type: Boolean,
      default: false
    },
    hasSearchQuery: {
      type: Boolean,
      default: false
    },
    maxSubheaderWidth: {
      type: Number,
      default: 390
    },
    hideActionButtons: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showIntercom () {
      window.Intercom('show')
    }
  }
}
</script>

<style scoped>
.secondary-btn {
  box-shadow: 0 1px 2px 0 rgba(4, 26, 75, 0.13), 0 0 0 1px rgba(0, 56, 108, 0.08);
  background-color: transparent;
  transition: background-color 100ms ease-in-out, box-shadow 100ms ease-in-out;
}
.secondary-btn:hover {
  box-shadow: none;
  background-color: #F6F8FA;
}
.fade-in {
  animation: fadeIn 100ms ease-in-out;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>